
export function personInTunnelData() {
  return [
    {
      positioningTime: "2026-02-26 17:25:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口钢筋班",
      deptId: 309,
      postId: 429,
      cardNo: "ys10",
      speed: 0,
      xCoordinate: 1.096611,
      yCoordinate: 0,
      postName: "钢筋工",
      isBatteryLow: false,
      name: "段霞",
      id: 11313,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:25:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口支护班",
      deptId: 306,
      postId: 426,
      cardNo: "ys01",
      speed: 0,
      xCoordinate: 5.884052,
      yCoordinate: 0,
      postName: "支护工",
      isBatteryLow: false,
      name: "顾玥傲",
      id: 11306,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:25:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口支护班",
      deptId: 306,
      postId: 426,
      cardNo: "ys02",
      speed: 0,
      xCoordinate: 7.473611,
      yCoordinate: 0,
      postName: "支护工",
      isBatteryLow: false,
      name: "黄淳美",
      id: 11307,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:25:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口支护班",
      deptId: 306,
      postId: 426,
      cardNo: "ys03",
      speed: 0,
      xCoordinate: 2.083976,
      yCoordinate: 0,
      postName: "支护工",
      isBatteryLow: false,
      name: "黎欣宜",
      id: 11308,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:25:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口支护班",
      deptId: 306,
      postId: 426,
      cardNo: "ys04",
      speed: 0,
      xCoordinate: 2.487938,
      yCoordinate: 0,
      postName: "支护工",
      isBatteryLow: false,
      name: "汪若萌",
      id: 11314,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:25:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口支护班",
      deptId: 306,
      postId: 426,
      cardNo: "ys05",
      speed: 0,
      xCoordinate: 9.930329,
      yCoordinate: 0,
      postName: "支护工",
      isBatteryLow: false,
      name: "傅雨泽",
      id: 11315,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:25:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口钢筋班",
      deptId: 309,
      postId: 429,
      cardNo: "ys06",
      speed: 0,
      xCoordinate: 9.727009,
      yCoordinate: 0,
      postName: "钢筋工",
      isBatteryLow: false,
      name: "徐汝鑫",
      id: 11309,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:25:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口钢筋班",
      deptId: 309,
      postId: 429,
      cardNo: "ys07",
      speed: 0,
      xCoordinate: 8.533612,
      yCoordinate: 0,
      postName: "钢筋工",
      isBatteryLow: false,
      name: "龙磊",
      id: 11310,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:25:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口钢筋班",
      deptId: 309,
      postId: 429,
      cardNo: "ys08",
      speed: 0,
      xCoordinate: 1.71064,
      yCoordinate: 0,
      postName: "钢筋工",
      isBatteryLow: false,
      name: "郑明远",
      id: 11311,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:25:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口钢筋班",
      deptId: 309,
      postId: 429,
      cardNo: "ys09",
      speed: 0,
      xCoordinate: 1.302811,
      yCoordinate: 0,
      postName: "钢筋工",
      isBatteryLow: false,
      name: "常佳昊",
      id: 11312,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
  ];
}

export function personInTunnelTodayData() {
  return [
    {
      positioningTime: "2026-02-26 17:27:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口钢筋班",
      deptId: 309,
      postId: 429,
      cardNo: "ys10",
      speed: 0,
      xCoordinate: 1.337448,
      yCoordinate: 0,
      postName: "钢筋工",
      isBatteryLow: false,
      name: "段霞",
      id: 11313,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:27:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口支护班",
      deptId: 306,
      postId: 426,
      cardNo: "ys01",
      speed: 0,
      xCoordinate: 1.777838,
      yCoordinate: 0,
      postName: "支护工",
      isBatteryLow: false,
      name: "顾玥傲",
      id: 11306,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:27:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口支护班",
      deptId: 306,
      postId: 426,
      cardNo: "ys02",
      speed: 0,
      xCoordinate: 6.655649,
      yCoordinate: 0,
      postName: "支护工",
      isBatteryLow: false,
      name: "黄淳美",
      id: 11307,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:27:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口支护班",
      deptId: 306,
      postId: 426,
      cardNo: "ys03",
      speed: 0,
      xCoordinate: 2.409814,
      yCoordinate: 0,
      postName: "支护工",
      isBatteryLow: false,
      name: "黎欣宜",
      id: 11308,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:27:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口支护班",
      deptId: 306,
      postId: 426,
      cardNo: "ys04",
      speed: 0,
      xCoordinate: 7.254763,
      yCoordinate: 0,
      postName: "支护工",
      isBatteryLow: false,
      name: "汪若萌",
      id: 11314,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:27:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口支护班",
      deptId: 306,
      postId: 426,
      cardNo: "ys05",
      speed: 0,
      xCoordinate: 4.045223,
      yCoordinate: 0,
      postName: "支护工",
      isBatteryLow: false,
      name: "傅雨泽",
      id: 11315,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:27:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口钢筋班",
      deptId: 309,
      postId: 429,
      cardNo: "ys06",
      speed: 0,
      xCoordinate: 8.80276,
      yCoordinate: 0,
      postName: "钢筋工",
      isBatteryLow: false,
      name: "徐汝鑫",
      id: 11309,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:27:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口钢筋班",
      deptId: 309,
      postId: 429,
      cardNo: "ys07",
      speed: 0,
      xCoordinate: 4.609857,
      yCoordinate: 0,
      postName: "钢筋工",
      isBatteryLow: false,
      name: "龙磊",
      id: 11310,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:27:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口钢筋班",
      deptId: 309,
      postId: 429,
      cardNo: "ys08",
      speed: 0,
      xCoordinate: 3.12165,
      yCoordinate: 0,
      postName: "钢筋工",
      isBatteryLow: false,
      name: "郑明远",
      id: 11311,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
    {
      positioningTime: "2026-02-26 17:27:30",
      tunnelNumber: "61c7f9e102a04215933468749eff7455",
      deptName: "进口钢筋班",
      deptId: 309,
      postId: 429,
      cardNo: "ys09",
      speed: 0,
      xCoordinate: 3.779509,
      yCoordinate: 0,
      postName: "钢筋工",
      isBatteryLow: false,
      name: "常佳昊",
      id: 11312,
      isButtonAlarm: false,
      isVibrating: false,
      batteryLevel: 80,
    },
  ];
}
